import NotificationTimer from './notification_timer';
import {useDispatch} from 'react-redux';
import {redeemFreeplayBonus} from '../../../../../reducers/notifications/actions';
import ModalsLib from '../../../../../lib/modals';

export default ({
    id,
    details,
    timestamp,
    disabled
}) => {
    const dispatch = useDispatch();

    return (
        <div className="notification-bonus freeplay"> 
            <div className="border"></div>
            <div className="bonus-content">
                <div className="bonus-info">
                    <div className="left">
                        {details.bonus_offer.game ? (
                            <div className="image" style={{backgroundImage: `url(${window.location.origin}/source/system/games/squad_new/${details.bonus_offer.game}.png)`}}></div>
                        ) : (
                            <div className="image"></div>
                        )}
                    </div>

                    <div className="right">
                        <div className="title">
                            {details.bonus_offer.title}

                            <span className="notification-time">
                                <NotificationTimer id={id} timestamp={timestamp} />
                            </span>
                        </div>
                        <div className="text" dangerouslySetInnerHTML={{__html: details.bonus_offer.text}}></div>
                    </div>
                </div>

                <div className="bonus-button" style={{
                    opacity: disabled ? 0.7 : 1,
                    cursor: disabled ? 'no-drop' : 'pointer'
                }} onClick={e => {
                    if(disabled)
                        return;

                    if(typeof details.bonus_offer.game !== 'undefined') 
                        dispatch(redeemFreeplayBonus(id, null));
                    else
                        ModalsLib.open('changeGame', {
                            redirect: false,
                            handler: game => {
                                ModalsLib.close();
                                dispatch(redeemFreeplayBonus(id, game));
                            }
                        }); 
                }}>{disabled ? 'Please wait...' : 'Claim FreePlay'}</div>
            </div>
        </div>
    )
}